import { Button } from "@mui/material";
import React from "react";
import { SimpleForm, TextInput, Edit, useRedirect, TopToolbar, PasswordInput, SelectInput } from 'react-admin';
import { getAllRoles } from "./roles";

const UserName = ({ record }) => {
    return <span>User {record ? `"${record.usename}"` : ""}</span>;
  };
  
const UserEditActions = ({ basePath, data, resource }) => {
    const redirect = useRedirect();
    return (
      <TopToolbar
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexDirection: "row",
        }}
      >
        {/* Add your custom actions */}
        <Button color="primary" onClick={() => redirect("/admin/api/users")}>
          Back
        </Button>
      </TopToolbar>
    );
  };

export const UserEdit = (props) => {
  // Get all roles including dynamically created ones
  const allRoles = getAllRoles();
  
  // Create role choices for the dropdown
  const roleChoices = Object.entries(allRoles).map(([key, value]) => {
    // Format the display name (capitalize first letter of each word)
    const displayName = key.replace(/([A-Z])/g, ' $1')
                         .replace(/^./, str => str.toUpperCase());
    return { id: value, name: displayName };
  });

  // Transform function to handle role formatting for API
  const transform = (data) => {
    // Ensure roles is always an array, even if it's a single string
    const roles = Array.isArray(data.roles) ? data.roles : [data.roles];
    return {
      ...data,
      roles: roles
    };
  };

  // Formatter for initial values to handle different role formats from API
  const formatRoles = (record) => {
    if (!record) return undefined;
    
    // Handle the case where roles might be an array but we need a single value for SelectInput
    if (Array.isArray(record.roles) && record.roles.length > 0) {
      return { ...record, roles: record.roles[0] };
    }
    return record;
  };

  return (
    <Edit 
        actions={<UserEditActions />}
        title={<UserName />}
        successMessage={"Successfully edit user"}
        transform={transform}
        initialValues={formatRoles}
        {...props}
        >
        <SimpleForm>
        <SelectInput
          label="Select Role"
          source="roles"
          fullWidth
          required
          choices={roleChoices}
        />

        <TextInput fullWidth source="username" />
        <TextInput fullWidth source="firstName" />
        <TextInput fullWidth source="lastName" />
        <PasswordInput fullWidth source="password" placeholder="Leave blank to keep current password" />
        </SimpleForm>
    </Edit>
  );
};